import { useMemo } from "react";
import { useAppSelector } from "@/src/store";
import { useNormalizedUser, NormalizedUser } from "@/src/hooks/useNormalizedUser";
import {
  ExporterUserDto,
  AccountSignInResponseDto,
} from "@/src/store/apis/auth/interface";

export interface SignupStatus {
  isFirstStepSignup: boolean;
  normalizedUser: NormalizedUser | null;
  userFromStore: ExporterUserDto | AccountSignInResponseDto | null;
}

export const useSignupStatus = (): SignupStatus => {
  const userFromStore = useAppSelector((state) => state.auth.user);
  const normalizedUser = useNormalizedUser(userFromStore);

  const isFirstStepSignup = useMemo(() => {
    return !!(
      normalizedUser &&
      userFromStore &&
      "hasExporterUser" in userFromStore &&
      userFromStore.hasExporterUser === false
    );
  }, [normalizedUser, userFromStore]);

  return {
    isFirstStepSignup,
    normalizedUser,
    userFromStore,
  };
};
